import { defineMessages } from 'react-intl';

export const i18n = defineMessages({
	showMoreTooltip: {
		id: 'contributors-macro.show-more-tooltip',
		defaultMessage: '{count} more...',
		description:
			'Tooltip text for the link that reveals hidden contributors beyond the limit. {count} is the number of hidden contributors.',
	},
	showMoreLabel: {
		id: 'contributors-macro.show-more-label',
		defaultMessage: '...',
		description: 'Label for the link that reveals hidden contributors beyond the limit.',
	},
	noContributorsDefault: {
		id: 'contributors-macro.no-contributors-default',
		defaultMessage: 'No contributors found for: {includeTypes} on selected page(s)',
		description:
			'Default message displayed when no contributors are found. {includeTypes} is a comma-separated list of contribution types.',
	},
	errorPreview: {
		id: 'contributors-macro.error-preview',
		defaultMessage: '{macroLabel} will be shown when you save your edit',
		description: 'Error message shown when the macro is used in a draft/preview context.',
	},
	errorUnsupportedContent: {
		id: 'contributors-macro.error-unsupported-content',
		defaultMessage: '{macroLabel} can only be used in pages, blog posts and comments',
		description: 'Error message shown when the macro is used in unsupported content types.',
	},
	error: {
		id: 'contributors-macro.error',
		defaultMessage: "We're unable to display the contributors. Refresh to try again",
		description: 'Generic error message displayed when the contributors macro fails to render.',
	},
	macroLabel: {
		id: 'contributors-macro.label',
		defaultMessage: 'Contributors',
		description: 'Display label for the contributors macro.',
	},
	separator: {
		id: 'contributors-macro.separator',
		defaultMessage: ', ',
		description: 'Separator between contributor names in the flat layout.',
	},
	lastActiveTime: {
		id: 'contributors-macro.last-active-time',
		defaultMessage: '({time})',
		description:
			'Displays the relative last active time for a contributor in parentheses. {time} is a relative time string like "2 hours ago".',
	},
});
